import { useMutation, useQueryClient } from 'react-query';
import {
  activateBettieAutoTopUp,
  type ActivateBettieAutoTopUpResponse
} from '../../services/bettieAutoTopUpService';

export function useActivateBettieAutoTopUp() {
  const queryClient = useQueryClient();
  return useMutation<ActivateBettieAutoTopUpResponse, Error, string>(activateBettieAutoTopUp, {
    onSuccess: () => {
      queryClient.invalidateQueries(['bettieAutoTopUp']);
    }
  });
}
